import palette from '../palette';

export default {
  root:{
    backgroundColor: palette.colors.darkBlack[500]
  }
};
